module.exports = __webpack_public_path__ + "static/img/partner_4.db5c3ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/partners/partner_4.png
// module id = 7tE0
// module chunks = 0